import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

import { bodyLink } from './ReviewPreviewCard.styles';

const { borderRadius, spacing, typography } = themeVariables;

/* 68px square, from the design. The theme has no sizing scale, so the one value the
   design states is stated here. */
const PHOTO_SIZE = '68px';

export const photoRow = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.md});
`;

export const photos = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xs});
`;

export const photoLink = css`
  display: block;
  flex-shrink: 0;
  width: ${PHOTO_SIZE};
  height: ${PHOTO_SIZE};
  border-radius: var(${borderRadius.md.mobile});
  /* The image fills the link, so the link has nothing of its own to show. */
  overflow: hidden;
`;

export const photo = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

/* Smaller than the card's other links: it sits beside the thumbnails rather than under
   the text, and at the body size it competes with them for the row. */
export const viewAllPhotos = css`
  ${bodyLink}
  flex-shrink: 0;
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  text-decoration: underline;
`;
